"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanUserData = exports.extractWorkEmail = exports.addUserKey = exports.hasEmailDomainData = exports.hasUserAuthData = exports.emailDomainType = exports.emailDomainLabel = exports.isRenew = void 0;
exports.httpApiCall = httpApiCall;
exports.validateEmail = validateEmail;
const auth_1 = require("../logic/auth");
const exenv_1 = require("exenv");
const tracking_1 = require("@food/tracking");
const track_1 = require("./track");
/**
 * Funzione per capire a partire dai dati di localStorage se siamo in un caso di rinnovo o di login
 */
const isRenew = () => !!((0, auth_1.getUserData)() && (0, auth_1.getLoginType)());
exports.isRenew = isRenew;
/**
 * Funzione per formattare in modo umano gli emailDomain
 * @param i - FIXME - Use proper types
 */
const emailDomainLabel = (i) => {
    let str = ['Cname', 'CGname', 'Sname', 'Rname'].reduce((p, c) => (i[c] && i[c].length > 0 ? i[c] : p), '');
    if (i.CountryName) {
        str += ' - ' + i.CountryName;
    }
    if (i.Tname) {
        str += ` (Team ${i.Tname})`;
    }
    return str;
};
exports.emailDomainLabel = emailDomainLabel;
// FIXME - Use proper types
const emailDomainType = (i) => {
    const labels = ['Company', 'Company Group', 'Service', 'Retailer'];
    return ['Cname', 'CGname', 'Sname', 'Rname'].reduce((p, c, k) => (i[c] && i[c].length > 0 ? labels[k] : p), '');
};
exports.emailDomainType = emailDomainType;
const dangerousRequestKeys = ['password', 'grantToken', 'cryptoRenewToken'];
const cleanServerRequest = (request) => {
    const cleanRequest = { ...request };
    dangerousRequestKeys.forEach((key) => {
        if (key in cleanRequest) {
            cleanRequest[key] = '*****';
        }
    });
    if (request.options && request.options.workEmailVerifyToken) {
        cleanRequest.options = {
            ...request.options,
            workEmailVerifyToken: '*****',
        };
    }
    return cleanRequest;
};
// Keep possible string explicit type-wise because compiler have to check '*****' is a valid value for field
const dangerousResponseKeys = ['cryptoRenewToken'];
const cleanServerResponse = (response) => {
    const cleanResponse = {
        ...response,
    };
    dangerousResponseKeys.forEach((key) => {
        if (key in cleanResponse) {
            cleanResponse[key] = '*****';
        }
    });
    if (cleanResponse.choices && cleanResponse.key === 'options.tosApproved') {
        cleanResponse.choices = cleanResponse.choices.map((choice) => choice.id);
    }
    if (cleanResponse.userAuth && cleanResponse.userAuth.authorization) {
        cleanResponse.userAuth = {
            ...cleanResponse.userAuth,
            authorization: '*****',
        };
    }
    return cleanResponse;
};
async function httpApiCall(body, endpoint, targetSite) {
    return new Promise((resolve) => {
        fetch(endpoint, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Target-Site': targetSite,
            },
            method: 'POST',
            body: JSON.stringify(body),
        })
            .then(async (response) => {
            const res = await response.json();
            (0, tracking_1.track)({
                ...track_1.authTrackOverride,
                action: {
                    type: 'auth_server_request',
                    request: cleanServerRequest(body),
                    response: {
                        json: cleanServerResponse(res),
                        code: response.status,
                    },
                },
            });
            resolve(res);
        })
            .catch((err) => {
            resolve({
                status: 500,
                success: false,
                type: '',
                message: err.message,
            });
        });
    });
}
function validateEmail(email) {
    if (!email || email.length === 0) {
        return false;
    }
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email.trim().toLowerCase());
}
const hasUserAuthData = (r) => r &&
    r.payload &&
    r.payload.userAuth &&
    r.payload.userAuth.auth &&
    r.payload.userAuth.auth.user;
exports.hasUserAuthData = hasUserAuthData;
const hasEmailDomainData = (r) => r && r.payload && r.payload.EmailDomainRow;
exports.hasEmailDomainData = hasEmailDomainData;
const addUserKey = (keys) => {
    if (!exenv_1.canUseDOM) {
        return;
    }
    const key = '@food/userKeys';
    const val = localStorage.getItem(key);
    const parsed = val ? JSON.parse(val) : [];
    const newParsed = parsed
        .concat(keys)
        .filter((key, index, arr) => arr.indexOf(key) === index);
    localStorage.setItem(key, JSON.stringify(newParsed));
};
exports.addUserKey = addUserKey;
/**
 * @description Funzione per estrarre la work email dalla risposta del server
 * @param r: IWrappedResponse
 * @return string
 */
const extractWorkEmail = (r) => r && r.payload && r.payload.workEmail;
exports.extractWorkEmail = extractWorkEmail;
const cleanUserData = (userAuthData) => ({
    ...userAuthData,
    authorization: '*****',
});
exports.cleanUserData = cleanUserData;
//# sourceMappingURL=misc.js.map